export const ConfirmCancelMessage = (
  <>
    You will lose all the changes you have made. <br />
    Are you sure you want to cancel?
  </>
);